import { useOutletContext } from 'react-router-dom'

import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

import { useFilter } from 'modules/performance_process/components/review/show/Filters/context'

export const ReviewerStrategyFilter = () => {
  const { reviewProcess } = useOutletContext<ReviewOverviewOutletContext>()
  const { value, setValue } = useFilter('reviewerStrategy')

  const labelByStrategy: Record<PerformanceReviewerStrategiesStrategyEnum, string> = {
    manager: i18n.t('performance_process.reviews.answer_evaluation.evaluation_type.manager.title'),
    self: i18n.t('performance_process.reviews.answer_evaluation.evaluation_type.self.title'),
    direct_reports: i18n.t(
      'performance_process.reviews.answer_evaluation.evaluation_type.direct_reports.title'
    ),
    peers: i18n.t('performance_process.reviews.answer_evaluation.evaluation_type.peers.title'),
  }

  const options =
    reviewProcess.reviewerStrategies?.map((strategy) => ({
      label: labelByStrategy[strategy],
      value: strategy,
    })) ?? []

  if (options.length === 0) return null

  return (
    <Filter.SingleChoice
      label={i18n.t('performance_process.insights.answers.filters.reviewer_strategy.title')}
      value={value}
      options={options}
      onValueChange={setValue}
      noFooter
    />
  )
}
